<template>
  <div class="home">
    <section id="products" class="section products-section">
      <div class="section-heading">
        <p class="section-kicker">产品矩阵</p>
        <h2>覆盖供应链业务的关键节点</h2>
        <p>
          从招采门户到数字货运，再到资讯与协同服务，用统一的平台体验连接企业、承运商、司机与上下游伙伴。
        </p>
      </div>

      <div class="product-grid">
        <article v-for="product in products" :key="product.title" class="product-card">
          <div class="product-copy">
            <span>{{ product.tag }}</span>
            <h3>{{ product.title }}</h3>
            <p>{{ product.desc }}</p>
          </div>
          <div class="screen-grid" :class="{ 'screen-grid-large': product.images.length > 4 }">
            <img v-for="image in product.images" :key="image" :src="image" :alt="product.title" />
          </div>
        </article>
      </div>
    </section>

    <section class="section value-section">
      <div class="value-copy">
        <p class="section-kicker">平台价值</p>
        <h2>把分散流程收束为可管理的数字闭环</h2>
        <p>
          通过线上公告、询价响应、合同履约、运输可视化、资金支付和发票管理，帮助企业降低沟通成本，提升业务透明度。
        </p>
      </div>
      <div class="value-list">
        <div v-for="item in values" :key="item.title" class="value-item">
          <span>{{ item.index }}</span>
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section partners-section">
      <div class="section-heading">
        <p class="section-kicker">合作伙伴</p>
        <h2>与产业伙伴一起建设可信供应链生态</h2>
      </div>
      <div class="partner-grid">
        <div v-for="partner in partners" :key="partner" class="partner-card">
          <img :src="partner" alt="合作伙伴" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      products: [
        {
          tag: "企业服务",
          title: "博缆五车",
          desc: "为供应链链条上的企业与业务环节提供在线协同、资源管理和数据化服务。",
          images: [
            require("@/assets/image/B6.png"),
            require("@/assets/image/B1.png"),
            require("@/assets/image/B2.png"),
            require("@/assets/image/B3.png"),
          ],
        },
        {
          tag: "招标采购",
          title: "招采门户",
          desc: "聚合采购公告、询价采购、响应管理与结果公示，让采购流程更清晰、更高效。",
          images: [
            require("@/assets/image/采购公告.png"),
            require("@/assets/image/询价采购.png"),
            require("@/assets/image/询价采购-详情.png"),
            require("@/assets/image/我要响应.png"),
          ],
        },
        {
          tag: "物流履约",
          title: "数字货运",
          desc: "支持派单、接单、电子合同、线上履约、运输可视化、在线支付与开票，推动传统物流业务数字化升级。",
          images: [
            require("@/assets/image/数字1.png"),
            require("@/assets/image/数字2.png"),
            require("@/assets/image/数字3.png"),
            require("@/assets/image/数字4.png"),
            require("@/assets/image/数字5.png"),
            require("@/assets/image/数字6.png"),
          ],
        },
        {
          tag: "行情资讯",
          title: "铜价资讯",
          desc: "提供与产业经营相关的价格资讯、市场动态和辅助决策信息，帮助企业把握采购节奏。",
          images: [
            require("@/assets/image/B5.png"),
            require("@/assets/image/B2.png"),
            require("@/assets/image/B3.png"),
            require("@/assets/image/B4.png"),
          ],
        },
      ],
      values: [
        {
          index: "01",
          title: "业务线上化",
          desc: "把公告、询价、响应、派单和履约流程搬到线上，减少线下沟通与人工流转。",
        },
        {
          index: "02",
          title: "过程可视化",
          desc: "关键节点实时留痕，采购、运输和结算状态清楚可追踪，便于管理和协同。",
        },
        {
          index: "03",
          title: "数据可沉淀",
          desc: "持续沉淀供应商、承运商、订单和资金数据，为后续经营分析提供基础。",
        },
      ],
      partners: [
        require("@/assets/image/合作伙伴1.png"),
        require("@/assets/image/合作伙伴2.png"),
        require("@/assets/image/合作伙伴3.png"),
        require("@/assets/image/合作伙伴4.png"),
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.home {
  background: #f6f8fb;
}

.section {
  padding: clamp(64px, 8vw, 112px) clamp(24px, 6vw, 96px);
}

.section-heading {
  max-width: 760px;
  margin: 0 auto clamp(34px, 5vw, 56px);
  text-align: center;

  h2 {
    margin-top: 12px;
    color: #101828;
    font-size: clamp(30px, 4vw, 46px);
    line-height: 1.18;
    font-weight: 800;
  }

  p:last-child {
    margin-top: 16px;
    color: #667085;
    font-size: 17px;
    line-height: 1.8;
  }
}

.section-kicker {
  color: #1268e8;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0;
}

.products-section {
  background: #fff;
}

.product-grid {
  display: grid;
  gap: 28px;
  max-width: 1280px;
  margin: 0 auto;
}

.product-card {
  display: grid;
  grid-template-columns: minmax(260px, 0.34fr) minmax(0, 0.66fr);
  gap: clamp(24px, 4vw, 48px);
  align-items: center;
  padding: clamp(24px, 4vw, 42px);
  background: #f8fbff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  box-shadow: 0 18px 46px rgba(16, 24, 40, 0.06);
}

.product-copy {
  span {
    display: inline-flex;
    align-items: center;
    height: 30px;
    padding: 0 10px;
    color: #1268e8;
    font-size: 13px;
    font-weight: 800;
    background: #eaf3ff;
    border-radius: 6px;
  }

  h3 {
    margin-top: 18px;
    color: #101828;
    font-size: clamp(25px, 3vw, 34px);
    line-height: 1.24;
    font-weight: 800;
  }

  p {
    margin-top: 14px;
    color: #667085;
    font-size: 16px;
    line-height: 1.8;
  }
}

.screen-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;

  img {
    display: block;
    width: 100%;
    aspect-ratio: 16 / 10;
    object-fit: cover;
    object-position: top center;
    background: #fff;
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 6px;
    box-shadow: 0 12px 26px rgba(16, 24, 40, 0.08);
  }
}

.screen-grid-large {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.value-section {
  display: grid;
  grid-template-columns: minmax(280px, 0.42fr) minmax(0, 0.58fr);
  gap: clamp(36px, 6vw, 76px);
  align-items: start;
  background: #f6f8fb;
}

.value-copy {
  max-width: 560px;

  h2 {
    margin-top: 12px;
    color: #101828;
    font-size: clamp(30px, 4vw, 46px);
    line-height: 1.18;
    font-weight: 800;
  }

  p:last-child {
    margin-top: 18px;
    color: #667085;
    font-size: 17px;
    line-height: 1.8;
  }
}

.value-list {
  display: grid;
  gap: 16px;
}

.value-item {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 20px;
  padding: 26px;
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;

  > span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    color: #1268e8;
    font-weight: 800;
    background: #eaf3ff;
    border-radius: 6px;
  }

  h3 {
    color: #101828;
    font-size: 20px;
    line-height: 1.35;
    font-weight: 800;
  }

  p {
    margin-top: 8px;
    color: #667085;
    font-size: 15px;
    line-height: 1.7;
  }
}

.partners-section {
  background: #fff;
}

.partner-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px;
  max-width: 1120px;
  margin: 0 auto;
}

.partner-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 126px;
  padding: 22px;
  background: #f8fbff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;

  img {
    display: block;
    max-width: 100%;
    max-height: 72px;
    object-fit: contain;
  }
}

@media screen and (max-width: 1080px) {
  .product-card,
  .value-section {
    grid-template-columns: 1fr;
  }

  .partner-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media screen and (max-width: 640px) {
  .section {
    padding-left: 18px;
    padding-right: 18px;
  }

  .product-card {
    padding: 20px;
  }

  .screen-grid,
  .screen-grid-large,
  .partner-grid {
    grid-template-columns: 1fr;
  }

  .value-item {
    grid-template-columns: 1fr;
  }
}
</style>
